import type { Messages } from "./en";
export const it: Messages = {
  "meta.title": "ArtLove365 - Dipinti a olio fatti a mano",
  "meta.description": "Riproduzioni a olio dipinte a mano dei più grandi capolavori del mondo e ritratti a olio su misura dipinti a partire dalle tue foto.",
  "nav.gallery": "Galleria",
  "nav.artists": "Artisti",
  "nav.custom": "Dipingi la mia foto",
  "nav.track": "Segui l'ordine",
  "home.eyebrow": "Dipinti a mano a olio, da veri artisti",
  "home.title": "Capolavori per le tue pareti. I tuoi ricordi, dipinti come capolavori.",
  "home.subtitle": "Scegli tra i dipinti più amati della storia o carica una tua foto. I nostri artisti la dipingono a mano su tela e te la spediscono a casa.",
  "home.ctaGallery": "Esplora la galleria",
  "home.ctaCustom": "Carica una foto",
  "home.stepsTitle": "Come funziona",
  "home.step1Title": "Scegli o carica",
  "home.step1Body": "Scegli un capolavoro oppure carica una foto della tua famiglia, del tuo animale o del tuo luogo preferito.",
  "home.step2Title": "Lo dipingiamo",
  "home.step2Body": "Un pittore professionista lavora su vera tela. Per gli ordini su misura approvi prima un bozzetto.",
  "home.step3Title": "Arriva da te",
  "home.step3Body": "Dopo l'asciugatura, il dipinto viene imballato con cura e spedito in tutto il mondo con tracciamento.",
  "home.featured": "Capolavori in evidenza",
  "gallery.title": "Galleria di capolavori",
  "gallery.subtitle": "Ogni dipinto è riprodotto a mano, a olio su tela - mai stampato.",
  "gallery.filterAll": "Tutti gli artisti",
  "gallery.empty": "Nessun dipinto trovato.",
  "artists.title": "I maestri",
  "artists.works": "Vedi le opere",
  "artwork.by": "di",
  "artwork.order": "Ordina questo dipinto",
  "artwork.notFound": "Dipinto non trovato.",
  "order.size": "Formato della tela",
  "order.frame": "Finitura",
  "frame.rolled": "Tela arrotolata (in un tubo)",
  "frame.stretched": "Su telaio, pronta da appendere",
  "frame.framed": "Su telaio + cornice in legno",
  "order.subjects": "Persone o animali nella foto",
  "order.price.base": "Dipinto",
  "order.price.frame": "Finitura",
  "order.price.custom": "Ritratto su misura",
  "order.price.shipping": "Spedizione",
  "order.price.free": "Gratuita",
  "order.price.total": "Totale",
  "order.contact": "Dati di spedizione",
  "order.name": "Nome e cognome",
  "order.email": "Email",
  "order.phone": "Telefono",
  "order.address": "Indirizzo",
  "order.city": "Città",
  "order.postalCode": "CAP",
  "order.country": "Paese",
  "order.notes": "Note per l'artista (facoltative)",
  "order.submit": "Procedi al pagamento",
  "order.submitting": "Invio dell'ordine…",
  "order.error": "Qualcosa è andato storto. Controlla il modulo e riprova.",
  "order.leadTime": "La pittura richiede 2-3 settimane, più 1 settimana di asciugatura prima della spedizione.",
  "custom.title": "Trasforma la tua foto in un dipinto a olio",
  "custom.subtitle": "Carica una foto nitida e ben illuminata. I nostri artisti la dipingeranno a mano - e approvi il bozzetto prima che iniziamo.",
  "custom.upload": "Scegli una foto",
  "custom.uploadHint": "JPG, PNG o WebP, fino a 20 MB. Più alta è la risoluzione, migliore è il dipinto.",
  "custom.uploading": "Caricamento…",
  "custom.uploaded": "Foto caricata",
  "custom.replace": "Usa un'altra foto",
  "custom.style": "Stile pittorico",
  "custom.style.classic": "Realismo classico",
  "custom.style.impressionist": "Impressionista (come Monet)",
  "custom.style.vangogh": "Pennellata espressiva (come Van Gogh)",
  "custom.style.modern": "Moderno, tavolozza morbida",
  "custom.needPhoto": "Carica prima una foto.",
  "track.title": "Segui il tuo ordine",
  "track.code": "Codice ordine",
  "track.submit": "Cerca ordine",
  "track.notFound": "Non abbiamo trovato ordini con questo codice ed email.",
  "track.placed": "Effettuato il",
  "success.title": "Grazie! Il tuo ordine è stato registrato.",
  "success.body": "Ti abbiamo inviato una conferma via email. Conserva il codice ordine per seguirne l'avanzamento.",
  "status.awaiting_payment": "In attesa di pagamento",
  "status.paid": "Pagato",
  "status.sketching": "Bozzetto",
  "status.painting": "In lavorazione",
  "status.drying": "In asciugatura",
  "status.shipped": "Spedito",
  "status.delivered": "Consegnato",
  "status.cancelled": "Annullato",
  "common.loading": "Caricamento…",
  "common.back": "Indietro",
  "footer.tagline": "Dipinti a olio fatti a mano, spediti in tutto il mondo.",
  "footer.follow": "Seguici",
  "footer.docs": "Aiuto e documentazione",
  "gallery.search": "Cerca dipinti o artisti…",
  "sketch.title": "Il tuo bozzetto è pronto",
  "sketch.body": "Controlla la composizione. Iniziamo a dipingere solo dopo la tua approvazione.",
  "sketch.approve": "Approva il bozzetto",
  "sketch.change": "Richiedi modifiche",
  "sketch.feedback": "Cosa dovremmo cambiare?",
  "sketch.send": "Invia",
  "sketch.approved": "Bozzetto approvato - abbiamo iniziato a dipingere.",
  "sketch.changesSent": "Grazie! L'artista ti invierà un bozzetto rivisto.",
  "checkout.title": "Pagamento",
  "checkout.demoBanner": "Modalità demo - il pagamento online non è ancora attivo. Non verrà addebitato nulla e non raccogliamo dati della carta.",
  "checkout.summary": "Riepilogo dell'ordine",
  "checkout.method": "Metodo di pagamento",
  "checkout.method.card": "Carta di credito / debito",
  "checkout.method.paypal": "PayPal",
  "checkout.method.wallet": "Apple Pay / Google Pay",
  "checkout.method.bank": "Bonifico bancario",
  "checkout.cardNumber": "Numero della carta",
  "checkout.expiry": "Scadenza (MM/AA)",
  "checkout.cvc": "CVC",
  "checkout.cardName": "Intestatario della carta",
  "checkout.paypalNote": "Verrai reindirizzato a PayPal per approvare il pagamento.",
  "checkout.walletNote": "Conferma con Face ID, Touch ID o il tuo telefono.",
  "checkout.bankNote": "Ti invieremo via email le nostre coordinate bancarie. L'ordine parte all'arrivo del bonifico (1-3 giorni lavorativi).",
  "checkout.pay": "Paga {amount}",
  "checkout.processing": "Elaborazione del pagamento…",
  "checkout.secure": "I pagamenti sono cifrati e gestiti dal nostro partner di pagamento. Non conserviamo mai i numeri delle carte.",
  "checkout.demoDoneTitle": "Pagamento simulato",
  "checkout.demoDoneBody": "Era una demo - non è stato addebitato nulla. Il tuo ordine è salvato e resta «In attesa di pagamento»; ti contatteremo per completare il pagamento.",
  "checkout.failTitle": "Pagamento rifiutato",
  "checkout.failBody": "La tua banca ha rifiutato il pagamento. Controlla i dati o prova un altro metodo.",
  "checkout.retry": "Riprova",
  "checkout.viewOrder": "Vedi il mio ordine",
  "track.payNow": "Paga ora",
  "browse.title": "Esplora",
  "browse.movements": "Movimenti artistici",
  "browse.museums": "Musei",
  "browse.subjects": "Soggetti",
  "browse.genres": "Generi",
  "artwork.year": "Anno",
  "artwork.size": "Dimensioni originali",
  "artwork.museum": "Museo",
  "artwork.movement": "Movimento",
  "artwork.genre": "Genere",
  "artwork.subjects": "Soggetti",
  "artwork.moreBy": "Altre opere di",
  "pager.prev": "Precedente",
  "pager.next": "Successiva",
  "count.paintings": "{n} dipinti",
  "fav.add": "Aggiungi ai preferiti",
  "fav.remove": "Rimuovi dai preferiti",
  "fav.title": "I miei preferiti",
  "fav.empty": "Nessun preferito per ora. Tocca il cuore su un dipinto che ami: ti aspetterà qui.",
  "fav.emptyCta": "Esplora la galleria",
  "fav.syncHint": "Accedi con Google per ritrovare i tuoi preferiti su ogni dispositivo.",
  "fav.saved": "Salvato nei preferiti",
  "fav.nav": "Preferiti",
  "account.signIn": "Accedi",
  "account.signOut": "Esci",
  "account.signedInAs": "Accesso effettuato come",
  "account.signInTitle": "Accedi ad ArtLove365",
  "viewer.open": "Visualizza a schermo intero",
  "viewer.close": "Chiudi",
  "viewer.hint": "Scorri o pizzica per ingrandire · trascina per esplorare · doppio clic per tornare",
  "share.button": "Condividi",
  "share.copied": "Link copiato",
  "artwork.story": "Su questo dipinto",
  "artwork.details": "Dettagli",
  "artwork.aboutArtist": "L'artista",
  "artwork.readArtist": "Scopri la vita di {name}",
  "artwork.relatedArtists": "Dipinti di artisti collegati",
  "rel.influenced_by": "Ha ispirato {artist}",
  "rel.influenced": "Ispirato da {artist}",
  "rel.student_of": "Maestro di {artist}",
  "rel.student": "Allievo di {artist}",
  "rel.movement": "Anche {movement}",
  "story.didYouKnow": "Lo sapevi?",
  "story.sources": "Fonti",
  "story.aiNote": "Scritto con l'aiuto dell'intelligenza artificiale a partire dalle fonti indicate. Hai notato un errore? Faccelo sapere.",
  "artist.relatedArtists": "Artisti collegati",
  "artist.worksBy": "Dipinti di {name}",
  "nav.how": "Come lavoriamo",
  "home.ctaArtists": "Scopri gli artisti",
  "home.discover": "Conoscici",
  "home.howCardTitle": "Come lavoriamo",
  "home.howCardBody": "Veri pittori, vera tela, colori a olio e pazienza. Scopri come un capolavoro rinasce a mano.",
  "home.customCardTitle": "La tua foto, dipinta a olio",
  "home.customCardBody": "Famiglia, coppie, animali, la casa in cui sei cresciuto - scopri come una foto diventa un dipinto.",
  "home.featuredArtists": "I grandi maestri",
  "home.browseMovements": "Esplora per movimento",
  "common.readMore": "Scopri di più",
  "how.title": "Come lavoriamo",
  "how.intro": "Ogni dipinto ArtLove365 è realizzato a mano, con colori a olio su vera tela, da pittori professionisti. Niente stampe, nessuna scorciatoia. Ecco cosa succede tra un capolavoro e la tua parete.",
  "how.s1t": "Tutto inizia da un dipinto che ami",
  "how.s1b": "Esplora migliaia di capolavori, leggi le loro storie e conserva nei preferiti quelli che ti emozionano.",
  "how.s2t": "Un pittore studia l'originale",
  "how.s2b": "Prima della prima pennellata, il pittore studia composizione, colore e il modo in cui il maestro stendeva il colore: l'ordine degli strati conta quanto i colori.",
  "how.s3t": "Dipinto a mano, strato dopo strato",
  "how.s3b": "L'olio si costruisce lentamente: un abbozzo, le masse principali, poi i dettagli e le velature. Una tela di medie dimensioni richiede da due a tre settimane di lavoro.",
  "how.s4t": "Controllato, poi lasciato asciugare",
  "how.s4b": "Un pittore esperto confronta la tela con l'originale. Il colore a olio ha poi bisogno di circa una settimana per asciugarsi prima di viaggiare in sicurezza.",
  "how.s5t": "Imballato con cura, spedito in tutto il mondo",
  "how.s5b": "I dipinti viaggiano arrotolati in un tubo rigido o montati su telaio in una scatola rinforzata, con tracciamento fino alla tua porta.",
  "how.materialsTitle": "Materiali",
  "how.materialsBody": "Colori a olio di qualità professionale, tela di cotone o lino preparata e vernice che protegge la superficie per decenni.",
  "how.customTitle": "Dipingere dalla tua foto",
  "how.customBody": "Per ritratti e scene personali aggiungiamo un passaggio: approvi un bozzetto della composizione prima che iniziamo a dipingere.",
  "custom.pageTitle": "Dipinti a olio su misura dalle tue foto",
  "custom.pageIntro": "Una foto custodisce un momento. Un dipinto lo fa durare. I nostri pittori trasformano le tue foto in ritratti e scene dipinti a mano a olio, nello stile che preferisci.",
  "custom.howTitle": "Come funziona",
  "custom.step1t": "Condividi una foto",
  "custom.step1b": "Basta una foto nitida; possiamo anche unirne diverse in un'unica scena.",
  "custom.step2t": "Approvi un bozzetto",
  "custom.step2b": "Il nostro pittore prepara la composizione. Non si dipinge nulla finché non sei soddisfatto.",
  "custom.step3t": "Lo dipingiamo a mano",
  "custom.step3b": "Olio su tela, strato dopo strato, nello stile che hai scelto.",
  "custom.step4t": "Arriva a casa",
  "custom.step4b": "Dopo l'asciugatura e un ultimo controllo, il dipinto viene imballato e spedito con tracciamento.",
  "custom.stylesTitle": "Scegli uno stile",
  "custom.styleDesc.classic": "Somiglianza fedele, luce morbida e dettagli fini, nella tradizione dei grandi maestri.",
  "custom.styleDesc.impressionist": "Luce e atmosfera in tocchi liberi e vibranti, come un pomeriggio d'estate di Monet.",
  "custom.styleDesc.vangogh": "Pennellata densa e vorticosa e colori intensi, ispirati a Van Gogh.",
  "custom.styleDesc.modern": "Forme pulite e una tavolozza morbida e contemporanea, perfetta per gli interni moderni.",
  "custom.occasionsTitle": "Amato per",
  "custom.occ.family": "Ritratti di famiglia",
  "custom.occ.couples": "Coppie e matrimoni",
  "custom.occ.pets": "Animali domestici",
  "custom.occ.children": "Bambini",
  "custom.occ.memorial": "In ricordo",
  "custom.occ.home": "Case e luoghi",
  "custom.tipsTitle": "Come scegliere una buona foto",
  "custom.tip1": "Ben a fuoco, soprattutto gli occhi.",
  "custom.tip2": "Luce diurna morbida; evita flash forti e filtri marcati.",
  "custom.tip3": "Volti abbastanza grandi da leggere bene le espressioni.",
  "custom.tip4": "Più foto? Possiamo riunire persone o animali in un unico dipinto.",
  "custom.explore": "Esplora gli stili nella galleria",
  "showcase.title": "Commissioni che abbiamo dipinto",
  "showcase.subtitle": "Dipinti reali realizzati per i nostri clienti, pubblicati con il loro consenso.",
  "showcase.all": "Tutti",
  "custom.occ.nail": "Decorazioni per nail salon",
  "custom.occ.other": "Altro",
  "home.newTitle": "Storie appena raccontate",
  "home.newWhy": "Gli ultimi dipinti ad avere la loro storia completa: qualcosa di nuovo ogni giorno.",
  "home.gemsTitle": "Gemme nascoste",
  "home.gemsWhy": "Meno famosi, altrettanto emozionanti. Dipinti davanti ai quali quasi tutti passano oltre - e non dovrebbero.",
  "taxon.faqTitle": "Curioso di sapere cos'è {name}?",
  "notFound.title": "Pagina non trovata",
};
